import React from 'react';
import LogInForm from '../forms/LogInForm';
import frameImage from '../../assets/Images/frame.png';
import SignUpForm from '../forms/SignUpForm';
import { FcGoogle } from 'react-icons/fc';

const LogInSignUpTemplate = ({ heading, desc1, desc2, formType, image, setLoginConfirmationModal, setSignupConfirmationModal }) => {

    return (
        <div>
            <div className='flex justify-between w-11/12 max-w-[1160px] mx-auto lg:py-12 flex-col-reverse lg:gap-y-12 gap-y-10 md:gap-y-0 md:gap-x-12 md:flex-row'>
                <aside className='w-11/12 max-w-[450px] mx-auto lg:mx-0'>
                    <div className='inline-block'>
                        <h2 className='lg:text-4xl sm:text-3xl text-2xl text-richblack-5 font-bold flex gap-x-3'>{heading}</h2>
                    </div>
                    <p className='flex text-[1.125rem] leading-[1.625rem] gap-y-3 mt-4 flex-col'>
                        <span className='text-richblack-100'>{desc1}</span>
                        <span className='text-blue-100 italic'>{desc2}</span>
                    </p>
                    <div>
                        {
                            formType === 'login' ? <LogInForm setConfirmationModal={setLoginConfirmationModal} /> : <SignUpForm setConfirmationModal={setSignupConfirmationModal} />
                        }
                    </div>
                    <button className='w-full flex justify-center items-center gap-x-2 py-[8px] px-[12px] rounded-[8px] mt-6 mb-8 font-medium text-richblack-100 border border-richblack-700'>
                        <FcGoogle className='text-2xl' /><span>{formType === 'login' ? 'Sign in with Google' : 'Sign up with Google'}</span>
                    </button>
                </aside>
                <aside>
                    <div className='relative w-11/12 hidden lg:inline-block max-w-[450px] mx-auto md:mx-0'>
                        <div>
                            <img
                                src={frameImage}
                                loading='lazy'
                                width={558}
                                height={504}
                                alt=''
                            />
                        </div>
                        <div>
                            <img
                                className='absolute z-10 md:-top-4 -top-2 md:right-4 right-2'
                                src={image}
                                loading='lazy'
                                width={558}
                                height={504}
                                alt=''
                            />
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    )
}

export default LogInSignUpTemplate;